import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { isOpenIsh } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { MarketplaceNotificationBadge } from "../outbound-order/marketplace-notification";

const catalogEntry = fgColumnEntries["marketplace-notification-status"];

export const MarketplaceNotificationStatusColumn: Column2<FulfillmentGroupData> =
  {
    key: catalogEntry.key,
    title: catalogEntry.title,
    renderNormalCell: ({ row }) => {
      if (isOpenIsh(row.status)) {
        return null;
      }
      return <MarketplaceNotificationBadge group={row} />;
    },
    width: catalogEntry.defaultWidth,
    alignment: ColumnAlignment.LEFT,
  };
